import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/guideManage',
  redirect: 'noredirect',
  name: 'guideManage',
  component: Layout,
  children: [
    {
      path: 'guideManage',
      component: () => import('@/views/guideManage/index.vue'),
      name: 'Apparatus',
      meta: {
        title: '指南管理',
        icon: 'equiptype',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
